import script from "./TablaTorneosDisputados.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaTorneosDisputados.vue?vue&type=script&setup=true&lang=ts"

import "./TablaTorneosDisputados.vue?vue&type=style&index=0&id=23ba5d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ba5d2a"]])

export default __exports__